<div fxFlex fxLayout="column">
  <header>
    <h2>Anlagenkennlinien-Werte
      @if (hilfetext | async; as text) {
        <mat-icon
          svgIcon="innogy_picto_speech-bubble_exclamationmark"
          aria-hidden="false"
          [attr.aria-label]="text"
          [matTooltip]="text"
          matTooltipPosition="right"
          matTooltipClass="multiline-tooltip"
        >
        </mat-icon>
      }
    </h2>

    <div class="buttons mat-form-field-wrapper">
      <div class="custom-mat-form-field-infix">
        @if (!readonly) {
          <button
            matButton="outlined"
            class="actionbutton"
            (click)="close(true)">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Abbrechen
          </button>
        }
        @if (!readonly) {
          <button mat-raised-button
                  matButton="filled"
            class="actionbutton"
            (click)="close()"
            data-qa="saveButton"
            [disabled]="form.invalid || disabled || readonly">
            <mat-icon>save</mat-icon>
            Übernehmen
          </button>
        }
        @if (readonly) {
          <button mat-raised-button
            class="actionbutton"
            (click)="close()"
            data-qa="saveButton">
            <mat-icon svgIcon="innogy_picto_close"></mat-icon>
            Schließen
          </button>
        }
      </div>
      @if (form.hasError('min') && form.touched) {
        <div class="mat-form-field-subscript-wrapper">
          <mat-error>
            {{ ERROR_MIN_VALUES }}
          </mat-error>
        </div>
      }
    </div>
  </header>

  <mat-divider></mat-divider>

  <div [formGroup]="form" fxFlex fxLayout="column" [fxLayoutGap]="LYT_GAP" class="content">

    <div class="flex-wrap">
      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_01MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 1 [m/s]</mat-label>
        <input formControlName="kwBei01ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei01ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei01ms"/>
        @if (f.kwBei01ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei01ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_02MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 2 [m/s]</mat-label>
        <input formControlName="kwBei02ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei02ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei02ms"/>
        @if (f.kwBei02ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei02ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_03MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 3 [m/s]</mat-label>
        <input formControlName="kwBei03ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei03ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei03ms"/>
        @if (f.kwBei03ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei03ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_04MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 4 [m/s]</mat-label>
        <input formControlName="kwBei04ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei04ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei04ms"/>
        @if (f.kwBei04ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei04ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_05MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 5 [m/s]</mat-label>
        <input formControlName="kwBei05ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei05ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei05ms"/>
        @if (f.kwBei05ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei05ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_06MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 6 [m/s]</mat-label>
        <input formControlName="kwBei06ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei06ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei06ms"/>
        @if (f.kwBei06ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei06ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_07MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 7 [m/s]</mat-label>
        <input formControlName="kwBei07ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei07ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei07ms"/>
        @if (f.kwBei07ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei07ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_08MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 8 [m/s]</mat-label>
        <input formControlName="kwBei08ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei08ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei08ms"/>
        @if (f.kwBei08ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei08ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_09MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 9 [m/s]</mat-label>
        <input formControlName="kwBei09ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei09ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei09ms"/>
        @if (f.kwBei09ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei09ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_10MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 10 [m/s]</mat-label>
        <input formControlName="kwBei10ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei10ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei10ms"/>
        @if (f.kwBei10ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei10ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_11MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 11 [m/s]</mat-label>
        <input formControlName="kwBei11ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei11ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei11ms"/>
        @if (f.kwBei11ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei11ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_12MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 12 [m/s]</mat-label>
        <input formControlName="kwBei12ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei12ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei12ms"/>
        @if (f.kwBei12ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei12ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_13MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 13 [m/s]</mat-label>
        <input formControlName="kwBei13ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei13ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei13ms"/>
        @if (f.kwBei13ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei13ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_14MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 14 [m/s]</mat-label>
        <input formControlName="kwBei14ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei14ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei14ms"/>
        @if (f.kwBei14ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei14ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_15MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 15 [m/s]</mat-label>
        <input formControlName="kwBei15ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei15ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei15ms"/>
        @if (f.kwBei15ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei15ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_16MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 16 [m/s]</mat-label>
        <input formControlName="kwBei16ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei16ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei16ms"/>
        @if (f.kwBei16ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei16ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_17MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 17 [m/s]</mat-label>
        <input formControlName="kwBei17ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei17ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei17ms"/>
        @if (f.kwBei17ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei17ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_18MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 18 [m/s]</mat-label>
        <input formControlName="kwBei18ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei18ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei18ms"/>
        @if (f.kwBei18ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei18ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_19MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 19 [m/s]</mat-label>
        <input formControlName="kwBei19ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei19ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei19ms"/>
        @if (f.kwBei19ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei19ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_20MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 20 [m/s]</mat-label>
        <input formControlName="kwBei20ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei20ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei20ms"/>
        @if (f.kwBei20ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei20ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_21MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 21 [m/s]</mat-label>
        <input formControlName="kwBei21ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei21ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei21ms"/>
        @if (f.kwBei21ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei21ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_22MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 22 [m/s]</mat-label>
        <input formControlName="kwBei22ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei22ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei22ms"/>
        @if (f.kwBei22ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei22ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_23MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 23 [m/s]</mat-label>
        <input formControlName="kwBei23ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei23ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei23ms"/>
        @if (f.kwBei23ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei23ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_24MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 24 [m/s]</mat-label>
        <input formControlName="kwBei24ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei24ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei24ms"/>
        @if (f.kwBei24ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei24ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_25MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 25 [m/s]</mat-label>
        <input formControlName="kwBei25ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei25ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei25ms"/>
        @if (f.kwBei25ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei25ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_26MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 26 [m/s]</mat-label>
        <input formControlName="kwBei26ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei26ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei26ms"/>
        @if (f.kwBei26ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei26ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_27MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 27 [m/s]</mat-label>
        <input formControlName="kwBei27ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei27ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei27ms"/>
        @if (f.kwBei27ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei27ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_28MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 28 [m/s]</mat-label>
        <input formControlName="kwBei28ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei28ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei28ms"/>
        @if (f.kwBei28ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei28ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_29MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 29 [m/s]</mat-label>
        <input formControlName="kwBei29ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei29ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei29ms"/>
        @if (f.kwBei29ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei29ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_30MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 30 [m/s]</mat-label>
        <input formControlName="kwBei30ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei30ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei30ms"/>
        @if (f.kwBei30ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei30ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_31MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 31 [m/s]</mat-label>
        <input formControlName="kwBei31ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei31ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei31ms"/>
        @if (f.kwBei31ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei31ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_32MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 32 [m/s]</mat-label>
        <input formControlName="kwBei32ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei32ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei32ms"/>
        @if (f.kwBei32ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei32ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_33MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 33 [m/s]</mat-label>
        <input formControlName="kwBei33ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei33ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei33ms"/>
        @if (f.kwBei33ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei33ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_34MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 34 [m/s]</mat-label>
        <input formControlName="kwBei34ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei34ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei34ms"/>
        @if (f.kwBei34ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei34ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>

      <mat-form-field>
        <redispatch-erzeugungsanlage-form-prefix matPrefix [feld]="Feld.FIELD_AK_35MS"
        [disabled]="!readonly && disabled"></redispatch-erzeugungsanlage-form-prefix>
        <mat-label>[kW] bei 35 [m/s]</mat-label>
        <input formControlName="kwBei35ms"
          [redispatchDisableControl]="disabled || readonly"
          data-qa="kwBei35ms"
          type="number"
          matInput
          name="anlagenkennlinie_kwBei35ms"/>
        @if (f.kwBei35ms.hasError('min')) {
          <mat-error>
            Bitte geben Sie einen Wert größer 0 ein
          </mat-error>
        }
        @if (f.kwBei35ms.hasError('pattern')) {
          <mat-error>
            Es sind nur natürliche Zahlen erlaubt
          </mat-error>
        }
      </mat-form-field>
    </div>
  </div>
</div>
